"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductField = void 0;
var ProductField;
(function (ProductField) {
    ProductField["id"] = "id";
    ProductField["titel"] = "titel";
    ProductField["kategorie"] = "kategorie";
    ProductField["sekundaereKategorie"] = "sekundaereKategorie";
    ProductField["tertiaereKategorie"] = "tertiaereKategorie";
    ProductField["modellnummerIntern"] = "modellnummerIntern";
    ProductField["modellnummer"] = "modellnummer";
    ProductField["shop"] = "shop";
    ProductField["kalkulationsfaktor"] = "kalkulationsfaktor";
    ProductField["steinpreis"] = "steinpreis";
    ProductField["einkaufspreis"] = "einkaufspreis";
    ProductField["verkaufspreis"] = "verkaufspreis";
    ProductField["gewicht"] = "gewicht";
    ProductField["direktGewichtAU333"] = "direktGewichtAU333";
    ProductField["direktGewichtAU375"] = "direktGewichtAU375";
    ProductField["direktGewichtAU585"] = "direktGewichtAU585";
    ProductField["direktGewichtAU750"] = "direktGewichtAU750";
    ProductField["verarbeitungsverlust"] = "verarbeitungsverlust";
    ProductField["facon"] = "facon";
    ProductField["steinanzahl"] = "steinanzahl";
    ProductField["kalkulationsfaktorSteine"] = "kalkulationsfaktorSteine";
    ProductField["gesamtkaratBrillant"] = "gesamtkaratBrillant";
    ProductField["gesamtkaratZirkonia"] = "gesamtkaratZirkonia";
    ProductField["stueckpreis"] = "stueckpreis";
    ProductField["rabattProzent"] = "rabattProzent";
    ProductField["rabattPreis"] = "rabattPreis";
    ProductField["preisAnzeigen"] = "preisAnzeigen";
    ProductField["breite"] = "breite";
    ProductField["hoehe"] = "hoehe";
    ProductField["stilrichtungA"] = "stilrichtungA";
    ProductField["stilrichtungB"] = "stilrichtungB";
    ProductField["material"] = "material";
    ProductField["steinqualitaet"] = "steinqualitaet";
    ProductField["schliffform"] = "schliffform";
    ProductField["ringform"] = "ringform";
    ProductField["istRing"] = "istRing";
    ProductField["kannGravur"] = "kannGravur";
    ProductField["lieferzeit"] = "lieferzeit";
    ProductField["laenge"] = "laenge";
    ProductField["ringgroessenVerfuegbarkeit"] = "ringgroessenVerfuegbarkeit";
    ProductField["verlaengerung"] = "verlaengerung";
    ProductField["zusatzinformationen"] = "zusatzinformationen";
    ProductField["farbsteinart"] = "farbsteinart";
    ProductField["oberflaechenveredelung"] = "oberflaechenveredelung";
    ProductField["geschlecht"] = "geschlecht";
    ProductField["hoeheDurchmesserOhrring"] = "hoeheDurchmesserOhrring";
    ProductField["diamantFarbe"] = "diamantFarbe";
    ProductField["diamantReinheit"] = "diamantReinheit";
    ProductField["lagerbestand"] = "lagerbestand";
    ProductField["marke"] = "marke";
    ProductField["verschluss"] = "verschluss";
    ProductField["farbe"] = "farbe";
    ProductField["beschreibung"] = "beschreibung";
    ProductField["bildAltText"] = "bildAltText";
})(ProductField = exports.ProductField || (exports.ProductField = {}));
//# sourceMappingURL=ProductField.js.map